<template>
  <div class="h-100">
<!--    loader  -->
    <div v-if="requestStatus" class="loading_page" style=" padding: 10px; background: #1e1e1e; opacity: 0.6;">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
    </div>


    <b-sidebar
        :visible="sideBarStatus"
        :backdrop="false"
        right
        id="paths-sidebar"
        sidebar-class="sidebar-lg"
        shadow
        style="opacity: 0.94"
        @hidden="hideSideBar"
        width="25%">


      <!--      #0e96b1-->
      <div v-if="false" class="loading_page" style=" padding: 10px; background: #1e1e1e; opacity: 0.2;">
        <orbit-spinner :animation-duration="1000" :size="50" :color="'white'"/>
      </div>

      <div dir="rtl" class="m-2">

        <b-tabs>
          <b-tab title-item-class="w-50">

            <template #title>
              <img class="mr-50" style="width: 18px" :src="require('@/assets/icons/path.png')" alt="">
              <span class="font-weight-bold">{{ $t('events')}}</span>
            </template>


            <app-timeline style="padding: 20px">
              <!--           primary -  warning  - info  - danger -->
              <app-timeline-item v-for="event in events" :key="event.id" :variant="event.variant"
                                 :style="{ background: event.id === selectedEventId ? '#38548c3d' : ''}"
                                 style="padding-left: 10px">

                <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                  <h6>{{event.name}} </h6>
                  <small class="timeline-item-time text-nowrap">{{event.time}}</small>
                </div>
                <div class="d-flex justify-content-between ">
                  <small class="">{{ event.ago }}</small>
                </div>
                <div class="d-flex justify-content-between ">
                  <p @click="fitOnEvent(event)">{{ event.title }}</p>
                </div>

              </app-timeline-item>

            </app-timeline>

          </b-tab>

          <b-tab title-item-class="w-50">
            <template #title>
              <img class="mr-50" style="width: 18px" :src="require('@/assets/icons/settings.svg')" alt="">
              <span class="font-weight-bold">{{ $t('settings')}}</span>
            </template>


            <div class="d-flex justify-content-between">
              <p> تتبع المعدة  </p>
              <b-form-checkbox
                  v-model="panTo"
                  :checked="panTo"
                  class="custom-control-primary"
                  name="check-button"
                  switch
              />
            </div>


            <div class="d-flex justify-content-between">
              <p>  نقاط التحرك</p>
              <b-form-checkbox
                  v-model="showMovePoints"
                  :checked="showMovePoints"
                  class="custom-control-primary"
                  name="check-button"
                  switch
              />
            </div>

            <div class="d-flex justify-content-between">
              <p>   ({{ stopsCount }}) نقاط التوقف </p>
              <b-form-checkbox
                  v-model="showStopPoints"
                  :checked="showStopPoints"
                  class="custom-control-danger"
                  name="check-button"
                  switch
              />
            </div>

          </b-tab>

        </b-tabs>

      </div>

    </b-sidebar>


<!--    map    -->
    <div dir="ltr" class="h-100">
      <div class="h-100" id="map" ref="mapContainer"></div>
    </div>

  </div>
</template>


<script>
import {
  BAlert,
  BAvatar,
  BAvatarGroup,
  BButton, BCard, BCardBody, BCardHeader, BCardText, BCardTitle,
  BCol,
  BCollapse,
  BForm, BFormCheckbox,
  BFormGroup, BFormInput,
  BFormInvalidFeedback, BImg, BMedia, BMediaAside, BMediaBody,
  BRow, BSidebar, BTab, BTable, BTabs
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { onMounted, onUnmounted, reactive, ref, watch } from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'
import axios from '@/libs/axios'
import { eventBus } from '@/main'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import { timeToString } from '@/utils/time.utils'
import router from '@/router'
import AlertIcon from '@/views/components/alert/AlertIcon.vue'
import Vue from 'vue'
import PointPopup from '@/views/maps/popup/PointPopup.vue'
import ContainerPopup from '@/views/maps/popup/ContainerPopup.vue'
import MarkerPopup from '@/views/maps/popup/MarkerPopup.vue'
import Queue from '@/utils/queue'
import webSocketManager from '@/services/webSocketManager'
import moment from 'moment'
import ToastContent from '@core/components/toastification/ToastificationContent.vue'
import trans from '@/libs/i18n'


export default {

  components: {
    BTabs,
    BFormInput,
    BTable,
    BTab,
    BCardText,
    BFormCheckbox,
    BAlert,
    AlertIcon,
    BCard,
    BCardHeader,
    BCardTitle,
    BSidebar,
    BMedia,
    BCardBody,
    BImg,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BAvatarGroup,
    AppTimeline,
    AppTimelineItem,
    vSelect,
    BFormInvalidFeedback,

    BCollapse,
    BButton,
    BRow,
    BCol,
    flatPickr,
    OrbitSpinner
  },

  setup() {

    const sideBarStatus = ref(true)
    const deviceId = router.currentRoute.params.id
    const from = router.currentRoute.params.start

    const requestStatus = ref(true)
    const mapContainer = ref(null);
    const map = ref(null);

    const deviceInfo = ref(null);
    const devices = ref([]);
    const devicePath = ref(null)

    const movingQueue = new Queue()

    const route = ref(null)
    const routeLine = ref(null)
    const events = ref([])

    const error = ref(null)

    const panTo = ref(false)
    const showPoints = ref(false)
    const showMovePoints = ref(false)
    const showStopPoints = ref(false)
    const showGeofences = ref(true)
    const showContainers = ref(true)

    const stopsCount = ref(0)

    const deviceMarkerLayers = L.layerGroup()
    const devicePathLayers = L.layerGroup()

    const devicePathMovingPointsLayers = L.layerGroup()
    const devicePathStopsPointsLayers = L.layerGroup()
    const areaLayers = L.layerGroup()

    const selectedEventMarker = ref(null)
    const selectedEventId = ref('')

    const info = Vue.extend(PointPopup)

    const myRenderer = L.canvas({ padding: 0.5 });
    const circleOptions = {
      renderer: myRenderer,
      fill: true,
      fillOpacity: 0.5,
      stroke: false
    }

    let lastEventId;


    let timeoutId;

    let device_category = 'default';

    const today = new Date();
    const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    const getDeviceUpdates = callable => {
      axios.get(`device/${deviceId}/live`)
          .then(response => {
            callable(response)
            timeoutId = setTimeout(() => {
              getDeviceUpdates(callable)
            }, 5000)
      })
    }

    const getDeviceHistory = async () => {
      try
      {
        const response = await axios.get(`device/${deviceId}/history`);
        deviceInfo.value = response.data.device

        if (response.data.history.length < 1) {
          return;
        }

        lastEventId = response.data.events[response.data.events.length - 1].id

        for (const i in response.data.events) {
          pushNewEvent(
              response.data.events[i],
              getVariant(response.data.events[i].type)
          )
        }

        initDeviceMarker(response.data.device)
        initDeviceHistoryRoute(response.data.history)
      }
      catch (err) {
        throw err
      }

      finally {

        requestStatus.value = false

        setTimeout(() => {

          getDeviceUpdates(response => {

            const data = response.data

            if (data.device_id in devices.value) {
              createNewPoint(data)
              _move(data)
            }

            if (data.event_id) {
              if (lastEventId !== data.event_id) {

                lastEventId = data.event_id

                Vue.$toast({
                  component: ToastContent,
                  props: {
                    title: getToastTitle(data.event_type),
                    icon: data.event_type,
                    text: data.geofence_name,
                    time: moment(data.event_devicetime).fromNow()
                  },
                });

                pushNewEvent({
                  id: data.event_id,
                  geofence: data.geofence_name,
                  time: data.event_devicetime,
                  latitude: data.event_latitude,
                  longitude: data.event_longitude,
                }, getVariant(data.event_type))

              }
            }
          })
        }, 5000)

      }
    }

    const updateTimesAgo = () => {
      events.value = events.value.map(event => ({
        ...event,
        ago: moment(event.time).fromNow() // Update the "time ago" value dynamically
      }));
    };

    getDeviceHistory()

    const createNewPoint = point => {

      try {
        switch (point.status) {

          case "moving":
            const movePoint = L.circleMarker([point.latitude, point.longitude], {
              ...circleOptions,
              color: '#3a865a', }).bindPopup(initNewPopup(point), {closeButton: false,})
            devicePathMovingPointsLayers.addLayer(movePoint)
            break
          case "stop":
            const stopPoint = L.circleMarker([point.latitude, point.longitude], {
              ...circleOptions,
              color: '#a91f0d'
            }).bindPopup(initNewPopup(point), {closeButton: false,})
            devicePathStopsPointsLayers.addLayer(stopPoint)
            stopsCount.value++
            break
        }
      }
      catch (e) {
        console.log('cannot push new point')}
    }

    const initDeviceHistoryRoute = points => {

      const arrayOfCoordinates = points.map(obj => [obj.latitude, obj.longitude]);
      if (arrayOfCoordinates.length > 0) {

        devicePath.value = new L.Polyline(arrayOfCoordinates, {
          smoothFactor: 2, color: '#5f27cd', weight: 10, opacity: 0.5 })

        devicePathLayers.addLayer(devicePath.value)
        devicePathLayers.addTo(map.value)
        map.value.fitBounds(devicePath.value.getBounds())

        points.map(point => {
          createNewPoint(point)
        })

        // start point
        const startPointImg = require(`@/assets/icons/flag2.png`)
        const startPointIcon = getIconWithImg(startPointImg)
        const startPointMarker = createMarkerPoint(
            arrayOfCoordinates[0],
            startPointIcon
        )

        startPointMarker.bindPopup(initNewPopup(points[0]), {closeButton: false,})
        startPointMarker.addTo(map.value)
        startPointMarker.setZIndexOffset(99)
      }
    }

    const pushNewEvent = (e, variant) => {
      events.value.push({
        id: e.id,
        name: variant[1],
        title: e.geofence,
        time: e.time,
        ago: moment(e.time).fromNow(),
        variant: variant[0],
        latitude: e.latitude,
        longitude: e.longitude,
      })
    }


    const initDeviceMarker = device => {

      if (!device.latitude) {
        return;
      }

      device_category = device.category
      const lat = parseFloat(device.latitude)
      const lng = parseFloat(device.longitude)
      const icon = getIcon(device.course, device.status, device.category)
      const deviceMarker = L.marker([lat, lng], {icon: icon})
          // .bindPopup(myPopup(deviceInfo), {closeButton: false,})

      deviceMarkerLayers.addLayer(deviceMarker)
      deviceMarkerLayers.addTo(map.value)
      deviceMarker.setZIndexOffset(99)
      devices.value[device.id] = deviceMarker
      deviceMarker.on('click', function(e) {})
      devices.value[device.id] = deviceMarker
    }

    const initNewPopup = p => {
      const pop = new info({
        propsData: {
          point: {
            speed: p.speed,
            time: p.devicetime,
            status: p.status
          }
        }
      })

      pop.$mount()
      return pop.$el
    }

    const getIcon = (angle, status = 'moving', cat = 'default') => {

      let img;

      try {
        img = require(`@/assets/markers/${cat}/${status}.svg`)
      } catch (e) {
        img = require(`@/assets/markers/${status}.svg`)
      }

      return L.divIcon({
        html: L.Util.template(`<div class="rotate-${angle}"><img src="${img}" alt=""></div>`),
        iconSize    : [30, 40], })
    }

    const getIconWithImg = img => {
      return L.divIcon({
        html: L.Util.template(`<div style="width: 30px"><img style="width: 30px" src="${img}" alt=""></div>`),
        iconSize    : [30, 40], })
    }

    const _move = data => {

      const icon = getIcon(data.device_angle, data.device_status, device_category)

      const marker = devices.value[data.device_id]

      marker.setLatLng([data.device_latitude, data.device_longitude]);
      marker.setIcon(icon)
      marker.bindPopup(myPopup(data), {closeButton: false,})

      deviceInfo.value.speed = data.device_speed
      deviceInfo.value.devicetime = data.device_devicetime
      deviceInfo.value.status = data.device_status

      if (devicePath.value) {
        devicePath.value.addLatLng([
            data.device_latitude,
          data.device_longitude
        ])
      }

      if (panTo.value) {
        map.value.flyTo(marker.getLatLng())
      }

    }

    const move = (message, time)  => {

      const icon = getIcon(message.course, message.status, device_category)
      const marker = devices.value[message.id]

      const moveto = {lat: message.latitude, lng: message.longitude}
      const current = marker.getLatLng();


      let deltalat = (moveto.lat - current.lat) / 100;
      let deltalng = (moveto.lng - current.lng) / 100;

      let delay = 10 * time;
      for (let i = 0; i < 100; i++) {
        (function(ind) {
          setTimeout(
              function() {
                let lat = marker.getLatLng().lat;
                let lng = marker.getLatLng().lng;
                lat += deltalat;
                lng += deltalng;

                marker.setLatLng([lat, lng]);
              }, delay * ind
          );
        })(i)
      }

      (function (msg,  icon, moveto, marker) {
        setTimeout(function() {

              deviceInfo.value.speed = msg.speed
              deviceInfo.value.devicetime = msg.devicetime
              deviceInfo.value.status = msg.status
              deviceInfo.value.timeago = timeToString(msg.devicetime)

              if (devicePath.value) {
                devicePath.value.addLatLng([moveto.lat, moveto.lng])
              }
            }, 5500 // 5.5s
        );

      })(message, icon, moveto, marker)


      marker.setIcon(icon)
      marker.bindPopup(myPopup(message), {closeButton: false,})

      if (panTo.value) {
        map.value.flyTo(marker.getLatLng())
      }
    }

    const incrementPointCount = message => {
      switch (message.status) {
        case "stop":
          stopsCount.value++
          break
        default:
          break
      }
    }

    const consumeQ = () => {

      setTimeout(function() {
        if (!movingQueue.isEmpty()) {
          const message = movingQueue.dequeue()
          incrementPointCount(message)
          move(message, 4,)
        }

        if (movingQueue.isRunning()) {
          consumeQ()
        }

        }, 6000
      );

    }

    const getVariant = type => {
      switch (type) {
        case 'geofenceEnter':
          return ['info', 'دخول منطقة']
        case 'deviceMoving':
          return ['info', 'تحرك المعدة']
        case 'deviceStopped':
          return ['danger', 'توقف المعدة']
        case 'geofenceExit':
          return ['danger', 'خروج من منطقة']
        default:
          return ['purple', type]
      }
    }

    const getToastTitle = type => {
      switch (type) {
        case 'geofenceEnter':
          return  'دخول منطقة'
        case 'geofenceExit':
          return  'خروج من منطقة'
        case 'deviceMoving':
          return  'المعدة تحركت'
        case 'deviceStopped':
          return 'المعدة توقفت'
        case 'lift':
          return 'رفع حاوية'
        default:
          return 'غير معروف'
      }
    }

    const drawRoute = (linestring) => {

      const options = {  weight: 5, fillOpacity: 0.3, opacity: 0.5, color: '#6D214F'}
      const coordinatesString = linestring.replace('LINESTRING (', '').replace(')', '');
      const coordinatePairs = coordinatesString.split(', ');
      const points = coordinatePairs.map(pair => pair.split(' ').map(Number))
      routeLine.value = L.polyline(points, options).addTo(map.value)
    }

    const drawArea = area => {

      const options = {  weight: 5, fillOpacity: 0.3, opacity: 0.5, color: 'blue'}
      const points = area.area.split('((')[1].slice(0, -2).split(', ')
      const P = L.polygon(points.map((v, i) => [
        parseFloat(v.split(' ')[0]), parseFloat(v.split(' ')[1])]),options)
          .bindTooltip(`<div class="g_name" style="background: white;
                                font-size:1rem;padding:5px;
                                border:1px solid; !important; ">${area.name}</div>`, {
            permanent: false, direction:"center", className: 'bindTooltipStyle'}).openTooltip()
      areaLayers.addLayer(P)
    }

    const createMarkerPoint = (point, icon) => {
      return L.marker(
          point,
          { icon: icon }
      )
    }

    const initMap = () => {

      if (mapContainer.value) {
        let map_center = store.state.auth.userData?.map?.center ?? [24.7136, 46.6753]
        map.value = L.map(mapContainer.value).setView(map_center, 13);

        const googleStreets = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',{
          maxZoom: 20,
          subdomains:['mt0','mt1','mt2','mt3']
        }).addTo(map.value);

        const googleHybrid = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{
          maxZoom: 20,
          subdomains:['mt0','mt1','mt2','mt3']
        })

        // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        // }).addTo(map.value);

        map.value.on('click', onMapClick);

        areaLayers.addTo(map.value)

        L.control.layers({googleStreets, googleHybrid }, {},{
          position: 'topleft'}).addTo(map.value)

      }
    };

    const onMapClick = (event) => {
      const { lat, lng } = event.latlng;

      // move(devices.value, 8, { lat, lng })

      // console.log(lat, lng)
      // containers.value.push([lat, lng])
      //
      // console.log(containers.value)

      // draw direction between these points

    };

    const getSocketInstance = async () => {
      if (webSocketManager.socket && webSocketManager.socket.readyState === WebSocket.OPEN) {
        return webSocketManager
      }
      await new Promise(resolve => setTimeout(resolve, 1000))
      return getSocketInstance()
    }

    const onSubmit = () => {

    }

    const handleBeforeUnload = (event) => {
      // perform before the page closed
      // sendMSG('stopDeviceTrace')
    };

    const sendMSG = async type => {
      let instance = await getSocketInstance()
      instance.send(JSON.stringify({
        "message_type": type,
        "deviceId": compactorId
      }));
    }

    const makePulseMarkerForSeconds = latLng => {
      const m = L.marker([latLng.latitude, latLng.longitude], { icon:
            L.divIcon({ className: 'pulse', iconSize: [15, 15] }) }).addTo(map.value);
      (function(ms) {
        setTimeout(function() {
              map.value.removeLayer(m)
            }, ms
        );
      })(10000)
    }

    const fitOnEvent = event => {
      selectedEventId.value = event.id
      if (!selectedEventMarker.value) {
        selectedEventMarker.value =
            L.marker([event.latitude, event.longitude], {
              icon: L.divIcon({ className: 'pulse', iconSize: [15, 15] }) })
                .addTo(map.value);

        (function(ms) {
          setTimeout(function() {
                map.value.removeLayer(selectedEventMarker.value)
                selectedEventMarker.value = null
                selectedEventId.value = 0
              }, ms
          );
        })(5000)
      }
      else {
        selectedEventMarker.value.setLatLng([
            event.latitude,
          event.longitude
        ])
      }

    }

    const hideSideBar = () => {
      sideBarStatus.value = false
    }

    let timer = null;

    onUnmounted(() => {
      movingQueue.stop()
      clearTimeout(timeoutId)
      clearInterval(timer);
    })

    onMounted( () => {

      window.addEventListener('beforeunload', handleBeforeUnload);
      document.getElementsByTagName('html')[0].dir = 'ltr'
      initMap();


      const CustomControl = L.Control.extend({
        onAdd: function(map) {

          const container = L.DomUtil.create('div', 'custom-control')

          const pathsButton = L.DomUtil.create('button', 'custom-button', container)
          const icon = L.DomUtil.create('img', 'button-icon', pathsButton);
          icon.src = require('@/assets/icons/path.png')
          pathsButton.addEventListener('click', function() {
            sideBarStatus.value = !sideBarStatus.value;
          })

          return container;
        }
      })

      const customControl = new CustomControl()
      customControl.addTo(map.value);
      timer = setInterval(updateTimesAgo, 60000);
    });

    watch(route, (route) => {
      drawRoute(route.area)
    })

    watch(showMovePoints, (showMovePoints) => {
      showMovePoints
          ? devicePathMovingPointsLayers.addTo(map.value)
          : devicePathMovingPointsLayers.remove()
    })

    watch(showStopPoints , (showStopPoints) => {
      showStopPoints
          ? devicePathStopsPointsLayers.addTo(map.value)
          : devicePathStopsPointsLayers.remove()
    })

    watch(showGeofences , (showGeofences) => {
      showGeofences
          ? areaLayers.addTo(map.value)
          : areaLayers.remove()
    })

    const myPopup = data =>  `<div class="custom-popup">
                <div class="header">${data.device_name}</div>
                <table class="custom-popup-table">
                   <tr>
                     <td>speed</td>
                     <td class="float-endx">${data.device_speed}</td>
                   </tr>
                    <tr>
                     <td>status</td>
                     <td class="float-endx">${data.device_status}</td>
                   </tr>
                    <tr>
                     <td>lastupdate</td>
                     <td class="float-endx">${ data.device_devicetime }</td>
                   </tr>
                   <tr>
                     <td>lastupdate</td>
                     <td class="float-endx">${ moment(data.device_devicetime).fromNow() }</td>
                   </tr>

                </table>
              </div>`

    return {
      sideBarStatus,
      panTo,
      showGeofences,
      showContainers,
      showPoints,
      showMovePoints,
      showStopPoints,
      stopsCount,

      selectedEventId,

      requestStatus, error,
      deviceInfo,
      mapContainer,

      map,
      devices,
      events,
      onSubmit,
      fitOnEvent,
      hideSideBar,
    }

  }

};
</script>

<style lang="less">

.custom-button {
  all: unset;
  display: inline-block;
  cursor: pointer;

  background: #1b2337;
  margin: 2px;
  padding: 2px;
  border-radius: 1px;

}

.h-100 > div {
  height: 100%;
}

.b-sidebar-outer{
  height: 0 !important;
}

.leaflet-map-pane svg {
  z-index: 100 !important;
}


.leaflet-div-icon {
  background: none !important;
  border: none !important;
}

.pulse {
  background: rgb(163, 241, 9);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  position: absolute;
  margin-left: -10px;
  margin-top: -10px;
  animation: pulse 1s ease-out infinite;
}

.pulse_red {
  display: block;
  border-radius: 50%;
  cursor: pointer;
  animation: pulse 2s infinite;
  width: 10px;
  height: 10px;
  color: red;
  background: red;
}

.pulse_warning {
  display: block;
  border-radius: 50%;
  cursor: pointer;
  animation: pulse 10s infinite;
  width: 12px;
  height: 12px;
  color: #ff9f43;
  background: #ff9f43;
}

.marker_point {
  display: block;
  border-radius: 50%;
  cursor: pointer;
  width: 10px;
  height: 10px;
  background: #3a865a;
}

@keyframes pulse {
  0% {box-shadow: 0 0 0 0;}
  70% {box-shadow: 0 0 0 15px rgba(0, 0, 0, 0);}
  100% {box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);}
}

.generate-rotate-rules(359);
.generate-rotate-rules(@n, @i: 0) when (@i =< @n) {
  .rotate-@{i} {
  transform: rotate(unit(@i, deg)); /* CSS3 */
  -moz-transform: rotate(unit(@i, deg)); /* Firefox */
  -webkit-transform: rotate(unit(@i, deg)); /* Webkit */
  -o-transform: rotate(unit(@i, deg)); /* Opera */
  -ms-transform: rotate(unit(@i, deg)); /* IE 9 */
}
  .generate-rotate-rules(@n, (@i + 1));
}

.button-icon {
  width: 25px;
}

.custom-button {
  all: unset;
  display: inline-block;
  cursor: pointer;

  background: white;
  margin: 2px;
  padding: 2px;
  border: 2px solid #1676e5;
  border-radius: 2px;

}


</style>
